var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "flex mdmax:flex-col shadow-border-b"
  }, [_c('div', {
    staticClass: "p-6 flex-1 shadow-border-r mdmax:shadow-border-b"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v(_vm._s(_vm.$t('admin.detail.userInfo')))]), _c('div', {
    staticClass: "mb-6 w-56"
  }, [_c('TextField', {
    attrs: {
      "label": _vm.$t('admin.detail.id'),
      "disabled": ""
    },
    model: {
      value: _vm.userDetail.id,
      callback: function callback($$v) {
        _vm.$set(_vm.userDetail, "id", $$v);
      },
      expression: "userDetail.id"
    }
  })], 1), _c('div', {
    staticClass: "flex items-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('TextField', {
    attrs: {
      "label": _vm.$t('admin.detail.name')
    },
    model: {
      value: _vm.userDetail.name,
      callback: function callback($$v) {
        _vm.$set(_vm.userDetail, "name", $$v);
      },
      expression: "userDetail.name"
    }
  })], 1), _c('div', {
    staticClass: "flex-1"
  }, [_c('TextField', {
    attrs: {
      "label": _vm.$t('admin.detail.email')
    },
    model: {
      value: _vm.userDetail.email,
      callback: function callback($$v) {
        _vm.$set(_vm.userDetail, "email", $$v);
      },
      expression: "userDetail.email"
    }
  })], 1)]), _c('div', {
    staticClass: "flex items-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('TextField', {
    attrs: {
      "type": "number",
      "label": _vm.$t('admin.detail.phone')
    },
    model: {
      value: _vm.userDetail.phone_number,
      callback: function callback($$v) {
        _vm.$set(_vm.userDetail, "phone_number", $$v);
      },
      expression: "userDetail.phone_number"
    }
  })], 1), _c('div', {
    staticClass: "flex-1"
  }, [_vm._v(" ")])])]), _c('div', {
    staticClass: "p-6 flex-1 mdmax:flex-auto mdmax:w-full"
  })]), _c('div', {
    staticClass: "p-6 flex justify-end items-center gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": _vm.$t('admin.detail.update'),
      "type": "primary",
      "disabled": _vm.isDisabled
    },
    on: {
      "action": function action($event) {
        return _vm.update();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": _vm.$t('admin.detail.delete'),
      "type": "delete"
    },
    on: {
      "action": function action($event) {
        return _vm.toggleDeleteConfirmation();
      }
    }
  })], 1), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleDeleteConfirmation,
      "width": "600px",
      "id": "delete-confirmation-modal"
    },
    on: {
      "close": function close($event) {
        return _vm.toggleDeleteConfirmation();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "flex items-center justify-start gap-6 mb-6"
  }, [_c('span', {
    staticClass: "flex-shrink-0"
  }, [_c('Alert', {
    attrs: {
      "color": "neutral-700"
    }
  })], 1), _c('div', {
    staticClass: "flex-col flex gap-2 items-start"
  }, [_c('p', {
    staticClass: "text-2xl font-bold"
  }, [_vm._v(_vm._s(_vm.$t('admin.detail.modalTitle')))]), _c('p', {
    staticClass: "text-sm text-neutral-500 text-left"
  }, [_vm._v(" " + _vm._s(_vm.$t('admin.detail.modalDesc')) + " ")])])]), _c('div', {
    staticClass: "flex justify-end gap-6"
  }, [_c('Button', {
    attrs: {
      "buttonText": _vm.$t('admin.detail.no'),
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.toggleDeleteConfirmation();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": _vm.$t('admin.detail.yes'),
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.confirmDelete();
      }
    }
  })], 1)])], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }